import { useState } from "react";

import loadingGreen from "../../images/loading_gray.gif";
import { FILE_FORMATS, HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { uploadFileToS3 } from "../../utils/s3Upload";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import FileUploadInput from "../FileUploadInput/FileUploadInput";
import Modal from "../Modal/Modal";
import { Container, MainButton } from "./FileUploadMandateModalStyles";

function FileUploadMandateModal(props) {
  const {
    damNum,
    updateElectronicMandateStatus,
    refreshBilling,
    getSenasaAndElectronicMandate,
  } = props;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [waitingServerResponse, updateWaitingServerResponse] = useState(false);
  const [showConfirmationModal, updateShowConfirmationModal] = useState(false);

  const onFileChange = (files) => {
    setSelectedFiles(files);
  };

  const onFileUpload = () => {
    if (waitingServerResponse) return;

    updateWaitingServerResponse(true);
    uploadFileToS3("electronic-mandate", selectedFiles, "mandato_electronico_")
      .then((urlFile) => updateDam(damNum, urlFile))
      .then((damData) => {
        if (updateElectronicMandateStatus) {
          updateElectronicMandateStatus(damData.electronic_mandate_status);
        }
        updateWaitingServerResponse(false);
        setSelectedFiles([]);
        toggleConfirmationModal();
      })
      .catch(() => updateWaitingServerResponse(false));
  };

  const onCancel = () => {
    props.hideModal();
  };

  const toggleConfirmationModal = () => {
    updateShowConfirmationModal(!showConfirmationModal);
  };

  return showConfirmationModal ? (
    <ConfirmationModal
      title={
        selectedFiles.length > 1
          ? "Documentos subidos con éxito"
          : "Documento subido con éxito"
      }
      message={
        (selectedFiles.length > 1
          ? "La carga de los documentos ha sido exitosa."
          : "La carga del documento ha sido exitosa.") +
        " Haga clic en entendido o cierre el diálogo para continuar."
      }
      toggleModal={() => {
        onCancel();
        toggleConfirmationModal();
        if (refreshBilling) {
          refreshBilling();
        }
        if (getSenasaAndElectronicMandate) {
          getSenasaAndElectronicMandate.retry();
        }
      }}
      onAccept={() => {
        onCancel();
        toggleConfirmationModal();
        if (refreshBilling) {
          refreshBilling();
        }
        if (getSenasaAndElectronicMandate) {
          getSenasaAndElectronicMandate.retry();
        }
      }}
    />
  ) : (
    <Modal onOutsideClick={onCancel}>
      <Container>
        <h1>Adjuntar documento de MANDATO ELECTRÓNICO</h1>
        <FileUploadInput
          maxFiles={1}
          onValueChange={onFileChange}
          value={selectedFiles}
          formats={[FILE_FORMATS.IMAGE, FILE_FORMATS.PDF]}
          disabled={waitingServerResponse}
        />
        <MainButton
          disabled={selectedFiles.length === 0 || waitingServerResponse}
          onClick={onFileUpload}
        >
          {waitingServerResponse && (
            <img
              src={loadingGreen}
              width="50"
              height="50"
              alt="Processing request"
            />
          )}
          Enviar Documento
        </MainButton>
      </Container>
    </Modal>
  );
}
export default FileUploadMandateModal;

function updateDam(damNum, urlFile) {
  return networkBackendRequest(
    `/dams/electronic-mandate-agent/${damNum}/`,
    HTTP_METHODS.PATCH,
    {},
    {
      electronic_mandate_status_option: "reviewing",
      electronic_mandate_doc: urlFile[0],
    }
  ).then((response) => response.json());
}
